import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PermissionGuard } from './guards/permission.guard';
import { ConsultationComponent } from './main/pages/consultation/consultation.component';
import { AppointmentListComponent } from './main/pages/appointment-list/appointment-list.component';
import { PatientListComponent } from './main/pages/patient/patient-list/patient-list.component';
import { UserListComponent } from './main/pages/users/user-list/user-list.component';
import { PatientDetailComponent } from './main/pages/patient/patient-detail/patient-detail/patient-detail.component';
import { WoundAssessmentComponent } from './main/pages/patient/wound-assessment/wound-assessment.component';
import { AssessmentQuestionsComponent } from './main/pages/assessment-questions/assessment-questions.component';
import { ForgotPasswordComponent } from './main/pages/auth/forgot-password/forgot-password.component';
import { LoginComponent } from './main/pages/auth/login/login.component';
import { ResetPasswordComponent } from './main/pages/auth/reset-password/reset-password.component';
import { SetNewPasswordComponent } from './main/pages/auth/set-new-password/set-new-password.component';
import { ChatComponent } from './main/pages/chat/chat.component';
import { DashboarMainComponent } from './main/pages/dashboard/dashboard-main/dashboard-main.component';
import { InfoPageComponent } from './main/pages/info/info-page.component';
import { OrganizationDetailComponent } from './main/pages/organization/organization-detail/organization-detail.component';
import { OrganizationsComponent } from './main/pages/organization/organizations/organizations.component';
import { PatientCreateComponent } from './main/pages/patient/patient-create/patient-create.component';
import { ProfileComponent } from './main/pages/profile/profile.component';
import { RoleFormComponent } from './main/pages/roles/role-form/role-form.component';
import { RoleListComponent } from './main/pages/roles/role-list/role-list.component';
import { WorkListComponent } from './main/pages/work-list/work-list.component';
import { WorklistDetailComponent } from './main/pages/worklist-detail/worklist-detail.component';
import { NotificationsComponent } from './main/pages/notifications/notifications.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'auth/login', component: LoginComponent },
  { path: 'questions', component: AssessmentQuestionsComponent },

  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'auth/set-new-password', component: SetNewPasswordComponent },
  {
    path: 'dashboard',
    component: ConsultationComponent,
    children: [
      {
        path: 'main',
        component: DashboarMainComponent,
        canActivate: [AuthGuard, PermissionGuard],
      },
      { path: '**', redirectTo: 'main' },
    ],
  },
  {
    path: 'organization',
    component: ConsultationComponent,
    children: [
      {
        path: 'organizations',
        component: OrganizationsComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['get_list_organization_claim'] },
      },
      {
        path: 'detail/:id',
        component: OrganizationDetailComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['get_list_organization_claim'] },
      },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'notifications',
    component: ConsultationComponent,
    children: [
      {
        path: 'notifications',
        component: NotificationsComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: 'user',
    component: ConsultationComponent,
    children: [
      {
        path: 'users',
        component: UserListComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['get_list_user_claim'] },
      },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'wound',
    component: ConsultationComponent,
    children: [{ path: '**', redirectTo: '/work-list/worklist' }],
  },
  {
    path: 'role',
    component: ConsultationComponent,
    children: [
      {
        path: 'list',
        component: RoleListComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['get_list_role_claim'] },
      },
      {
        path: 'create',
        component: RoleFormComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['create_role_claim'] },
      },
      {
        path: 'edit/:id',
        component: RoleFormComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['update_role_claim'] },
      },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'patient',
    component: ConsultationComponent,
    children: [
      {
        path: 'list',
        component: PatientListComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['get_list_patient_claim'] },
      },
      {
        path: 'create',
        component: PatientCreateComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['create_patient_claim'] },
      },
      {
        path: 'detail/:id',
        component: PatientDetailComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['get_patient_by_id_claim'] },
      },
      {
        path: ':patientId/wound/:woundId/assessment',
        component: WoundAssessmentComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['get_patient_by_id_claim'] },
      },
      {
        path: 'edit/:id',
        component: PatientCreateComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: { permissions: ['update_patient_claim'] },
      },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'appointment',
    component: ConsultationComponent,
    children: [
      {
        path: 'list',
        component: AppointmentListComponent,
        canActivate: [AuthGuard],
      },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'work-list',
    component: ConsultationComponent,
    children: [
      {
        path: 'worklist',
        component: WorkListComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: [
            'get_list_wound_claim',
            'get_list_wound_consultation_claim',
          ],
        },
      },
      {
        path: 'detail/:id/:woundId',
        component: WorklistDetailComponent,
        // canActivate: [AuthGuard, PermissionGuard],
      },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'infoPage',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'info', component: InfoPageComponent },
      {
        path: 'create-version',
        loadComponent: () =>
          import(
            './main/pages/version-management/create-version/create-version.component'
          ).then((m) => m.CreateVersionComponent),
      },
      {
        path: 'edit-version/:id',
        loadComponent: () =>
          import(
            './main/pages/version-management/create-version/create-version.component'
          ).then((m) => m.CreateVersionComponent),
      },
      {
        path: 'version-management',
        loadComponent: () =>
          import(
            './main/pages/version-management/version-list/version-list.component'
          ).then((m) => m.VersionListComponent),
      },
      { path: '**', redirectTo: 'info' },
    ],
  },
  {
    path: 'profile',
    component: ConsultationComponent,
    data: { permissions: ['update_user_claim'] },
    children: [
      { path: 'detail', component: ProfileComponent },
      { path: 'info', component: ProfileComponent },
    ],
  },
  {
    path: 'chat/:groupId',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: ChatComponent }],
  },
  { path: '**', redirectTo: '/dashboard' },
];
